<template>
  <section v-if="shouldRender" class="home-section" :class="`home-section--${variant}`">
    <home-section-header v-if="title" :title="title" :subtitle="subtitle" :eyebrow="eyebrow" />
    <home-section-error v-if="error" @retry="$emit('retry')" />
    <home-section-skeleton v-else-if="loading" :variant="skeletonVariant" :count="skeletonCount" />
    <home-section-empty v-else-if="isEmpty && showEmpty" />
    <slot v-else />
  </section>
</template>

<script>
import HomeSectionHeader from "./HomeSectionHeader.vue";
import HomeSectionSkeleton from "@/components/home/states/HomeSectionSkeleton.vue";
import HomeSectionEmpty from "@/components/home/states/HomeSectionEmpty.vue";
import HomeSectionError from "@/components/home/states/HomeSectionError.vue";

export default {
  name: "HomeSection",
  components: {
    HomeSectionHeader,
    HomeSectionSkeleton,
    HomeSectionEmpty,
    HomeSectionError,
  },
  props: {
    title: { type: String, default: "" },
    subtitle: { type: String, default: "" },
    eyebrow: { type: String, default: "" },
    loading: { type: Boolean, default: false },
    error: { type: Boolean, default: false },
    isEmpty: { type: Boolean, default: false },
    showEmpty: { type: Boolean, default: false },
    variant: { type: String, default: "default" },
    skeletonVariant: { type: String, default: "cards" },
    skeletonCount: { type: Number, default: 5 },
  },
  computed: {
    shouldRender() {
      return this.loading || this.error || !this.isEmpty || this.showEmpty;
    },
  },
};
</script>
